export default "__VITE_ASSET__Dl9wQYlL__"